import { type ElementRef, type LabelHTMLAttributes } from 'react';
import { tv, type VariantProps } from 'tailwind-variants';

import { cn } from '../lib/utils';

const labelVariants = tv({
  base: 'text-sm font-medium text-uniform-gray-700 dark:text-uniform-gray-300',
  variants: {
    required: {
      true: "after:content-['*'] after:ml-0.5 after:text-red-500"
    }
  }
});

type LabelVariants = VariantProps<typeof labelVariants>;

interface LabelProps extends LabelHTMLAttributes<ElementRef<'label'>> {
  text: string;
  required?: boolean;
}

function Label({ text, required, className, ...props }: LabelProps) {
  return (
    <label className={cn(labelVariants({ required }), className)} {...props}>
      {text}
    </label>
  );
}

export { Label, labelVariants };
export type { LabelProps, LabelVariants };
